import { Injectable } from '@angular/core';
import { AppRouteHelper } from '@app/shared/helpers/app-route.helper';
import * as Sentry from '@sentry/angular-ivy';
import { map, skip } from 'rxjs/operators';
import { FEATURE_FLAGS } from '@app/infrastructure/feature-flag-manager/feature-flag-list';
import { FeatureFlagManagerService } from '@app/infrastructure/feature-flag-manager/feature-flag-manager.service';
@Injectable({
	providedIn: 'root',
})
export class SentryService {
	span: Sentry.Span;

	constructor(private featureFlagManager: FeatureFlagManagerService) {
		this.getFeatureFlags();
	}

	public endSpan(): void {
		if (this.span) {
			this.span.end();
		}
	}
	private getFeatureFlags(): void {
		this.featureFlagManager.flags$
			.pipe(
				skip(1),
				map((flags: Record<string, string>) => {
					return {
						isFlagEnabled: !!flags[FEATURE_FLAGS.ENABLE_OPTIMIZATION_HUB],
					};
				}),
			)
			.subscribe(({ isFlagEnabled }) => {
				this.startSentrySpan(isFlagEnabled);
			});
	}

	private startSentrySpan(isFlagEnabled: boolean) {
		let isDashboard = false;
		let isOptimizationHub = false;
		if (window.location.pathname === '/') {
			isOptimizationHub = isFlagEnabled;
		} else {
			isDashboard = window.location.pathname === `/${AppRouteHelper.dashboard}`;
			isOptimizationHub = window.location.pathname === `/${AppRouteHelper.optimizationHub}`;
		}
		const isSentryAvailable = !!Sentry.getClient();
		if ((isDashboard || isOptimizationHub) && isSentryAvailable) {
			this.startSpan(isDashboard);
		}
	}

	private startSpan(isDashboard: boolean): void {
		this.span = Sentry.startInactiveSpan({
			name: isDashboard ? 'Dashboard Page Load' : 'Insights Page Load',
		});
	}
}
